import { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

export interface TabInfo {
    label: string;
    content: React.ReactNode;
}

interface HorizontalTabPanelProps {
    tabs: TabInfo[];
}

export const HorizontalTabPanel = ({ tabs }: HorizontalTabPanelProps) => {
    const [tabValue, setTabValue] = useState(0);

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabValue(newValue);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={tabValue} onChange={handleTabChange} aria-label="horizontal tabs">
                    {tabs.map((tab, index) => (
                        <Tab label={tab.label} key={index} />
                    ))}
                </Tabs>
            </Box>
            {tabs.map((tab, index) => (
                <TabPanel value={tabValue} index={index} key={index}>
                    {tab.content}
                </TabPanel>
            ))}
        </Box>
    );
};
